
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "AABDOCAAA",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/AABDOCAAA.vue